// extracted by mini-css-extract-plugin
export default {"contactInfo":"ContactInfo_contactInfo__OkoQ-","emailLink":"ContactInfo_emailLink__f80Wf","marginBottom":"ContactInfo_marginBottom__m8Byq"};